import { GlyphCircle } from '@visx/glyph';
import Stack from '../../../Stack';
import styled from 'styled-components';

const colors = {
    tiktok: 'tiktok_pink',
    google: 'google_blue',
    instagram: 'instagram_orange',
    overview: 'purple_500',
};

export const DataSourceGlyphCircle = styled(GlyphCircle)`
    fill: ${({ theme, $dataSource }) => theme[colors[$dataSource]]};
    stroke-width: 4px;
    stroke: ${({ theme }) => theme.white};
`;

export const TooltipDate = styled.div`
    font-weight: 400;
    color: ${({ theme }) => theme.gray_600};
    font-size: 0.75rem;
`;

export const TooltipName = styled.div`
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.2;
    color: ${({ theme }) => theme.black};
    text-transform: capitalize;
    overflow: hidden;
    overflow-wrap: anywhere;
    word-break: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
`;

const colorsByDataSource = {
    google: 'google_blue',
    instagram: 'instagram_orange',
    tiktok: 'tiktok_pink',
    prediction: 'purple_500',
};

export const TooltipMetricLabelWrapper = styled(Stack).attrs(
    ({ $space = '.125rem' }) => ({
        $space,
    }),
)`
    border-left: solid 2px
        ${({ theme, $dataSource, $strokeColor }) =>
            $strokeColor ||
            theme[colorsByDataSource[$dataSource]] ||
            theme.gray_600};
    padding-left: 0.625rem;
`;

export const TooltipMetric = styled.div`
    font-size: 1.125rem;
    font-weight: 700;
    color: ${({ theme }) => theme.black};
    text-transform: uppercase;
    font-style: ${({ $estimated }) => ($estimated ? 'italic' : 'normal')};
    opacity: ${({ $estimated }) => ($estimated ? 0.6 : 1)};
`;

export const TooltipMetricLabel = styled.div`
    font-size: 0.75rem;
    font-weight: 400;
    color: ${({ theme, $estimated }) =>
        $estimated ? theme.black : theme.gray_600};
    font-style: ${({ $estimated }) => ($estimated ? 'italic' : 'normal')};
    opacity: ${({ $estimated }) => ($estimated ? 0.6 : 1)};
`;

export const TooltipEstimateNote = styled.div`
    font-size: 0.5625rem;
    font-style: italic;
    color: ${({ theme }) => theme.black};
    opacity: 0.6;
    margin-top: 0.125rem;
`;
